<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">14</h2>
<p class="vers"><span>Meiner</span> Begierden sind
viele, mein<br class="calibre1"/>
Schrei heischt Mitleid, aber du hast mich<br class="calibre1"/>
noch immer gerettet durch hartes Verweigern,<br class="calibre1"/>
mit dieser strengen Gnade hast<br class="calibre1"/>
du mein Leben durch und durch gewirkt.</p>
<p class="vers">Tag für Tag machst du mich würdig<br class="calibre1"/>
der einfachen, großen Gaben, die du mir<br class="calibre1"/>
ungebeten gabst – des Himmels, des<br class="calibre1"/>
Lichts, dieses Leibes, Lebens und Geistes<br class="calibre1"/>
– und rettest mich aus der Gefahr des<br class="calibre1"/>
Übermaßes der Wünsche.</p>
<p class="vers">Es gibt Zeiten, wo träge ich zögre und<br class="calibre1"/>
andre, wo ich erwache und eile, mein<br class="calibre1"/>
Ziel zu suchen; doch grausam birgst du<br class="calibre1"/>
dich vor mir.</p>
<p class="vers">Tag für Tag machst du mich würdig deines<br class="calibre1"/>
vollen Empfangs, indem du dich immer<br class="calibre1"/>
versagst und rettest mich vor der Gefahr<br class="calibre1"/>
der schwachen, unsicheren Wünsche. <a id="page19" title="mabarosa/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0015.vue?c39a06b0